import { useMemo } from "react";
import { usePatientCase } from "../usePatientCase";
import { useDiseasesSections } from "./useDiseasesSections";

export function useGetDiseasesInPlan() {
  const { inPlanSections: featuresSections } = useDiseasesSections();

  const {
    patientCase: { diseasesToIncludeInPlan, diseasesToRemoveFromPlan },
  } = usePatientCase();

  return useMemo(() => {
    const topDiseases = featuresSections[0]?.elements?.map((d) => ({
      disease: d?.qf,
    }));

    let planDiseases = diseasesToIncludeInPlan
      ? [
          ...topDiseases,
          ...diseasesToIncludeInPlan?.map((d) => ({ disease: d?.feature })),
        ]
      : topDiseases;

    planDiseases = planDiseases.filter(
      (q) => !diseasesToRemoveFromPlan?.some((qf) => qf.id === q.disease.id),
    );

    return planDiseases;
  }, [diseasesToIncludeInPlan, diseasesToRemoveFromPlan, featuresSections]);
}
